import { isFullscreenState } from "../Composables/useIsFullscreen.mjs";
const index = {
  computed: {
    /**
     * @deprecated Is to be removed in v9.0.0 with Vue 3 migration.
     *             Use `composables/useIsFullscreen` instead.
     */
    isFullscreen() {
      return isFullscreenState.value;
    }
  }
};
export {
  index as default
};
